import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { getHeaderTooltip } from "../tooltips";
import { ReactComponent as MinusIcon } from "../../../../../assets/utils/images/svgs/Minus-grey.svg";

export default function ContractNameHeader({
  contract,
  usersCount,
  toggleContractVisibility,
  filters = [],
  setFilters,
  users,
  resetAllFilters,
}) {
  const selected = filters.find((f) => f.isSelected) ?? filters[0];

  const handleChange = (e) => {
    const value = e.target.value;
    setFilters((prev) =>
      prev.map((f) => {
        const match = String(f.id) === value || f.name === value;
        return { ...f, isSelected: match };
      })
    );
  };

  console.log(contract, "contract");
  const fullName =
    contract?.name ?? contract?.contractName ?? contract?.fullName ?? "";

  return (
    <div className="d-flex gap-2 align-items-center">
      <div className="d-flex gap-2 justify-content-start align-items-center">
        <Tippy
          content={fullName}
          placement="top"
          arrow
          className="custom-tooltip"
          appendTo={() => document.body}
          delay={[120, 0]}
          disabled={!fullName || fullName === contract?.abbr}
        >
          <div
            className="planscreen__th--first cursor-pointer"
            onClick={resetAllFilters}
            style={{ cursor: "pointer" }}
          >
            {contract?.abbr} (
            {users?.length === usersCount ? users?.length : `${usersCount}/${users?.length}`}
            )
          </div>
        </Tippy>

        <Tippy
          content={getHeaderTooltip("CONTRACT_HIDE")}
          placement="top"
          arrow
          className="custom-tooltip"
        >
          <span>
            <MinusIcon
              className="cursor-pointer"
              onClick={() => toggleContractVisibility(contract?.id, false)}
            />
          </span>
        </Tippy>
      </div>

      {filters.length > 0 && contract?.id > 0 && (
        <Tippy
          content={getHeaderTooltip("FILTER_VERVANGERS")}
          placement="top"
          arrow
          className="custom-tooltip"
        >
          <span>
            <select
              className="planscreen__select planscreen__select--contract"
              value={String(selected?.id ?? selected?.name ?? "")}
              onChange={handleChange}

            >
              {filters.map((f) => (
                <option key={f.id ?? f.name} value={String(f.id ?? f.name)}>
                  {f.name?.length > 12 ? `${f.name.substring(0, 12)}...` : f.name}
                </option>
              ))}
            </select>
          </span>
        </Tippy>
      )}
    </div>
  );
}